import { Component } from '@angular/core';
import {environment} from "../../../../environments/environment";
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent {
  constructor(private router: Router, private auth: AuthService) {}
  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }
  protected readonly environment = environment;
}
